/** Heading and lead of a wizard step, in the Lumen type scale. */
export default function StepHeading({ heading, lead }: { heading: string; lead: string }) {
  return (
    <div>
      <h3 className="m-0 font-bold text-[22px] text-fg leading-tight">{heading}</h3>
      <p className="mt-1.5 text-fg-muted text-sm">{lead}</p>
    </div>
  );
}
